module.exports = __webpack_public_path__ + "static/banner-img-2-d56916471e6d5bd25c00f94d9581982f.png";